"use strict";

var _require = require("lodash"),
    assign = _require.assign;

var bsonObjectId = require("bson-objectid");

var getReverseComplementSequenceString = require("./getReverseComplementSequenceString");

var _require2 = require("ve-range-utils"),
    getSequenceWithinRange = _require2.getSequenceWithinRange,
    normalizePositionByRangeLength = _require2.normalizePositionByRangeLength,
    reversePositionInRange = _require2.reversePositionInRange;

module.exports = function cutSequenceByRestrictionEnzyme(pSequence, circular, restrictionEnzyme) {
  if (restrictionEnzyme.forwardRegex.length === 0 || restrictionEnzyme.reverseRegex.length === 0) {
    var returnArray = [];
    returnArray.error = "Cannot cut sequence. Enzyme restriction site must be at least 1 bp long.";
    return returnArray;
  }
  var forwardRegExpPattern = new RegExp(restrictionEnzyme.forwardRegex, "ig");
  var sequence = pSequence;

  var cutsitesForward = cutSequence(forwardRegExpPattern, restrictionEnzyme, sequence, circular);
  var cutsitesReverse = [];
  if (restrictionEnzyme.forwardRegex !== restrictionEnzyme.reverseRegex) {
    var revSequence = getReverseComplementSequenceString(sequence);
    cutsitesReverse = cutSequence(forwardRegExpPattern, restrictionEnzyme, revSequence, circular);
    cutsitesReverse = cutsitesReverse.map(function (cutsite) {
      return reverseAllPositionsOfCutsite(cutsite, sequence.length);
    });
  }
  return cutsitesForward.concat(cutsitesReverse);

  function reverseAllPositionsOfCutsite(cutsite, rangeLength) {
    cutsite.start = reversePositionInRange(cutsite.start, rangeLength, false);
    cutsite.end = reversePositionInRange(cutsite.end, rangeLength, false);
    cutsite.topSnipPosition = reversePositionInRange(cutsite.topSnipPosition, rangeLength, true);
    cutsite.bottomSnipPosition = reversePositionInRange(cutsite.bottomSnipPosition, rangeLength, true);
    if (cutsite.cutsTwice) {
      cutsite.upstreamTopSnip = reversePositionInRange(cutsite.upstreamTopSnip, rangeLength, true);
      cutsite.upstreamBottomSnip = reversePositionInRange(cutsite.upstreamBottomSnip, rangeLength, true);
    }
    cutsite.recognitionSiteRange.start = reversePositionInRange(cutsite.recognitionSiteRange.start, rangeLength, false);
    cutsite.recognitionSiteRange.end = reversePositionInRange(cutsite.recognitionSiteRange.end, rangeLength, false);
    return assign({}, cutsite, {
      start: cutsite.end,
      end: cutsite.start,
      overhangBps: getReverseComplementSequenceString(cutsite.overhangBps),
      topSnipPosition: cutsite.bottomSnipPosition,
      bottomSnipPosition: cutsite.topSnipPosition,
      upstreamTopSnip: cutsite.upstreamBottomSnip,
      upstreamBottomSnip: cutsite.upstreamTopSnip,
      upstreamTopBeforeBottom: !!cutsite.upstreamTopBeforeBottom,
      topSnipBeforeBottom: !!cutsite.topSnipBeforeBottom,
      recognitionSiteRange: {
        start: cutsite.recognitionSiteRange.end,
        end: cutsite.recognitionSiteRange.start
      },
      forward: false
    });
  }
};

function cutSequence(forwardRegExpPattern, restrictionEnzyme, sequence, circular) {
  var restrictionCutSites = [];
  var restrictionCutSite = void 0;
  var recognitionSiteLength = restrictionEnzyme.site.length;
  var originalSequence = sequence;
  var originalSequenceLength = sequence.length;
  if (circular) {
    //if the sequence is circular, we send in double the sequence
    //we'll deduplicate the results afterwards!
    sequence += sequence;
  }
  var currentSequenceLength = sequence.length;

  var matchIndex = sequence.search(forwardRegExpPattern);
  var startIndex = 0;
  var subSequence = sequence;

  while (matchIndex !== -1) {
    var recognitionSiteRange = {};
    var start = void 0; //start and end should fully enclose the enzyme snips and the recognition site!
    var end = void 0;
    var upstreamTopSnip = null; //upstream top snip position
    var upstreamBottomSnip = null; //upstream bottom snip position
    var upstreamTopBeforeBottom = false;
    var topSnipPosition = null; //downstream top snip position
    var bottomSnipPosition = null; //downstream bottom snip position
    var topSnipBeforeBottom = false;

    var fitsWithinSequence = false;
    // if (matchIndex + startIndex + recognitionSiteLength - 1 >= sequence.length) { // subSequence is too short
    //     break;
    // }

    recognitionSiteRange.start = matchIndex + startIndex;
    start = recognitionSiteRange.start; //this might change later on!

    recognitionSiteRange.end = matchIndex + recognitionSiteLength - 1 + startIndex;
    end = recognitionSiteRange.end; //this might change later on!

    //we need to get the snip sites, top and bottom for each of these cut sites
    //as well as all of the bp's between the snip sites

    //if the cutsite is type 1, it cuts both upstream and downstream of its recognition site (cutsite type 0's cut only downstream)
    if (restrictionEnzyme.cutType === 1) {
      //double cutter, add upstream cutsite here
      upstreamTopSnip = recognitionSiteRange.end - restrictionEnzyme.usForward;
      upstreamBottomSnip = recognitionSiteRange.end - restrictionEnzyme.usReverse;
      if (upstreamTopSnip >= 0 && upstreamBottomSnip >= 0) {
        fitsWithinSequence = true;
        if (upstreamTopSnip < upstreamBottomSnip) {
          if (start > upstreamTopSnip) {
            start = upstreamTopSnip + 1;
          }
          upstreamTopBeforeBottom = true;
        } else {
          if (start > upstreamBottomSnip) {
            start = upstreamBottomSnip + 1;
          }
        }
        upstreamTopSnip = normalizePositionByRangeLength(upstreamTopSnip, originalSequenceLength, true);
        upstreamBottomSnip = normalizePositionByRangeLength(upstreamBottomSnip, originalSequenceLength, true);
      } else {
        upstreamTopSnip = null;
        upstreamBottomSnip = null;
      }
    }

    //add downstream cutsite here
    topSnipPosition = recognitionSiteRange.start + restrictionEnzyme.topSnipOffset;
    bottomSnipPosition = recognitionSiteRange.start + restrictionEnzyme.bottomSnipOffset;
    if (bottomSnipPosition <= currentSequenceLength && topSnipPosition <= currentSequenceLength) {
      fitsWithinSequence = true;
      if (topSnipPosition > bottomSnipPosition) {
        if (topSnipPosition > recognitionSiteRange.end) {
          end = topSnipPosition - 1;
        }
      } else {
        if (bottomSnipPosition > recognitionSiteRange.end) {
          end = bottomSnipPosition - 1;
        }
        topSnipBeforeBottom = true;
      }
      topSnipPosition = normalizePositionByRangeLength(topSnipPosition, originalSequenceLength, true);
      bottomSnipPosition = normalizePositionByRangeLength(bottomSnipPosition, originalSequenceLength, true);
    } else {
      topSnipPosition = null;
      bottomSnipPosition = null;
    }

    if (fitsWithinSequence && start >= 0 && end >= 0 && start < originalSequenceLength && end < currentSequenceLength) {
      //only push cutsites onto the array if they are fully contained within the boundaries of the sequence!
      //and they aren't duplicated
      start = normalizePositionByRangeLength(start, originalSequenceLength, false);
      end = normalizePositionByRangeLength(end, originalSequenceLength, false);
      recognitionSiteRange.start = normalizePositionByRangeLength(recognitionSiteRange.start, originalSequenceLength, false);
      recognitionSiteRange.end = normalizePositionByRangeLength(recognitionSiteRange.end, originalSequenceLength, false);
      var cutRange = {
        start: -1,
        end: -1
      };

      if (topSnipPosition !== bottomSnipPosition) {
        //there is only a cut range if the snips don't snip at the exact same spot on top and bottom
        cutRange = topSnipBeforeBottom ? {
          start: topSnipPosition,
          end: normalizePositionByRangeLength(bottomSnipPosition - 1, originalSequenceLength)
        } : {
          start: bottomSnipPosition,
          end: normalizePositionByRangeLength(topSnipPosition - 1, originalSequenceLength)
        };
      }
      var overhangBps = getSequenceWithinRange(cutRange, originalSequence);

      restrictionCutSite = {
        id: bsonObjectId().str,
        start: start,
        end: end,
        topSnipPosition: topSnipPosition,
        bottomSnipPosition: bottomSnipPosition,
        topSnipBeforeBottom: topSnipBeforeBottom,
        overhangBps: overhangBps,
        overhangSize: overhangBps.length,
        upstreamTopBeforeBottom: upstreamTopBeforeBottom,
        upstreamTopSnip: upstreamTopSnip,
        annotationTypePlural: "cutsites",
        upstreamBottomSnip: upstreamBottomSnip,
        recognitionSiteRange: recognitionSiteRange,
        forward: true,
        name: restrictionEnzyme.name,
        restrictionEnzyme: restrictionEnzyme
      };
      restrictionCutSites.push(restrictionCutSite);
    }

    // Make sure that we always store the previous match index to ensure
    // that we are always storing indices relative to the whole sequence,
    // not just the subSequence.
    startIndex = startIndex + matchIndex + 1;

    // Search again on subSequence, starting from the index of the last match + 1.
    subSequence = sequence.substring(startIndex, sequence.length);
    matchIndex = subSequence.search(forwardRegExpPattern);
  }
  return restrictionCutSites;
}